window.SMTX.blacklistedDomains = [
  'gmail',
  'yahoo',
  'hotmail',
  'proton',
  'zoho',
  'yandex',
  'mail',
  'rambler',
  'fastmail',
  'aol',
  'live',
  'icloud',
  'outlook',
  'com',
];
